import { useEffect, useRef, useState } from 'react';

/** Déclenche un pulse visuel quand le joueur dézoome d'un niveau (pas au chargement ni au reset). */
export function useDezoomPulse(activeLevel: number) {
  const prevLevel = useRef(activeLevel);
  const [pulsing, setPulsing] = useState(false);

  useEffect(() => {
    if (activeLevel === prevLevel.current + 1) {
      setPulsing(true);
      const id = window.setTimeout(() => setPulsing(false), 580);
      prevLevel.current = activeLevel;
      return () => window.clearTimeout(id);
    }
    prevLevel.current = activeLevel;
    setPulsing(false);
  }, [activeLevel]);

  return pulsing;
}
